enum Options {
  ONE = "incorrect",
  TWO = "stolen",
  THREE = "unauthorized",
  FOUR = "dmd2",
}
enum Languages {
  Danish = "da",
  English = "en",
  Finish = "fi",
  Norweigian = "no",
  Swedish = "sv",
  DaneInEnglish = "da-en",
  FinnInEnglish = "fi-en",
  FinnInSwedish = "fi-sv",
  NordbaggeInEnglish = "no-en",
  SwedeInEnglish = "sv-en",
}
type Brands = {
  [key: string]: {
    [key in Options]: {
      [key in Languages]: string;
    };
  };
};

import { brandRedirectMap } from "@/brands";

const brands: Brands = {};

// Dead Cobrands/MiniCobrands??
brands[
  "corpmastercard"
] = require("../data/email-receiver/corpmastercard.json"); // DNB or Eurocard by Invitation?? probably not used?

// Soon to be dead Cobrands
// brands["diners"] = require("../data/email-receiver/diners.json");

// Own brands
brands["eurocard"] = require("../data/email-receiver/eurocard.json");
brands["airplus"] = require("../data/email-receiver/airplus.json");
brands[
  "eurocardinternational"
] = require("../data/email-receiver/eurocardinternational.json"); // probably not used??
brands["sebkort"] = require("../data/email-receiver/sebkort.json");
brands["seb"] = brands["sebkort"];
brands["sebcorp"] = require("../data/email-receiver/sebcorp.json");
brands["sebcorplimit"] = require("../data/email-receiver/sebcorplimit.json");
brands["sebcredit"] = require("../data/email-receiver/sebcredit.json");
brands["sebdebit"] = require("../data/email-receiver/sebdebit.json");
brands["sebselected"] = require("../data/email-receiver/sebselected.json");
brands["spendwise"] = require("../data/email-receiver/spendwise.json");

// Cobrands (only exists if we want to add their logo and branding)
brands["esso"] = brands["sebkort"];
brands["globecard"] = brands["sebkort"];
brands["saseurobonusmc"] = brands["sebkort"];

// MiniCobrands with own emails
brands["op"] = require("../data/email-receiver/op.json");

// MiniCobrands (only exists if we want to add their logo and branding)
brands["circlek"] = brands["sebkort"];
brands["dnb"] = brands["corpmastercard"];

brands["finnair"] = brands["sebkort"];
brands["ingo"] = brands["sebkort"];
brands["jyske"] = brands["sebkort"];
brands["landkreditt"] = brands["sebkort"];
brands["nknyckel"] = brands["sebkort"];
brands["nordicchoiceclubmc"] = brands["sebkort"]; // now called Strawberry
brands["strawberry"] = brands["sebkort"];
brands["scandicfriends"] = brands["sebkort"];
brands["opelkortet"] = brands["sebkort"];
brands["saabkortet"] = brands["sebkort"];
brands["sjprio"] = brands["sebkort"];
brands["volvo"] = brands["sebkort"];

function getSupportEmail(
  origBrand: string,
  country: string | undefined,
  locale: string,
  form: "incorrect" | "unauthorized" | "stolen" | "dmd2",
): string {
  const brand = brandRedirectMap[origBrand] || origBrand;

  if (!brands[brand]) {
    return "";
  }

  const language = country || locale;
  return (
    brands[brand][form][language as Languages] ??
    brands[brand][form][Languages.English]
  );
}

function getInvalidCountryQueryString(
  country: string | undefined,
  locales: readonly string[],
) {
  if (!country) {
    return "";
  }
  if (Array.isArray(country)) {
    return "Invalid country";
  }
  return locales?.includes(country)
    ? ""
    : "Invalid country, should match languages";
}

export { getInvalidCountryQueryString, getSupportEmail };
